import { AuxSegmentedControl } from "@blk/aladdin-react-components-es";
import { isEqual } from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { preview } from "common/constants";
import { useWidgetCurrentChartType, useWidgetComponentProps, useWidgetCurrentChartSeriesTypes } from "components/widgets/hooks/use-current-widget";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setCurrentStatusChartType, setCurrentChartSeriesTypes } from "store/current-dashboard";
import { getCurrentLocalTime } from "common/date-utils";
const { donut, barChart, lineChart, stackedBars, treeMapChart } = language.en.skeleton.settingsMenu.chartType;
const listAvailableChart = (availableCharts, widgetId) => {
    if (availableCharts === "SingleDimension") {
        const disabled = widgetId === preview.widgetId;
        return [
            { disabled, eventData: { chartType: "InsDonutChart" }, label: donut },
            { disabled, eventData: { chartType: "insHorizontalBarDatapointChart" }, label: barChart },
            { disabled, eventData: { chartType: "InsTreeMapChart" }, label: treeMapChart }
        ];
    }
    else if (availableCharts === "TimeSeriesCharts") {
        return [
            { eventData: { chartSeriesTypes: ["line"], chartType: "InsTimeSeriesChart" }, label: lineChart },
            { eventData: { chartSeriesTypes: ["column"], chartType: "InsTimeSeriesChart" }, label: stackedBars }
        ];
    }
    return [];
};
const areChartSeriesTypesEqual = (e, chartSeriesTypes) => e.eventData.chartSeriesTypes &&
    isEqual(chartSeriesTypes, e.eventData.chartSeriesTypes);
const isChartTypeEqual = (e, chartType) => e.eventData.chartType && e.eventData.chartType === chartType;
const isChecked = (e, chartType, chartSeriesTypes) => {
    if (areChartSeriesTypesEqual(e, chartSeriesTypes) && isChartTypeEqual(e, chartType)) {
        e.checked = true;
    }
    else if (!e.eventData.chartSeriesTypes && isChartTypeEqual(e, chartType)) {
        e.checked = true;
    }
    else {
        e.checked = false;
    }
};
export const InsSettingsChartType = ({ sectionId, widgetId }) => {
    const dispatch = useDispatch();
    const chartSeriesTypes = useWidgetCurrentChartSeriesTypes(sectionId, widgetId), chartType = useWidgetCurrentChartType(sectionId, widgetId);
    const { userSettings } = useWidgetComponentProps(sectionId, widgetId), { chartTypeAvailable } = userSettings || {};
    const onControlSelectionChanged = (data) => {
        const eventDataChartType = data.detail.data.eventData.chartType ?? "";
        const eventDataChartSeriesTypes = data.detail.data.eventData.chartSeriesTypes;
        appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.ChangeWidgetSettingsWidgetType, properties: { LocalTimestamp: getCurrentLocalTime() } }, { selectedType: data.detail.data.label });
        dispatch(setCurrentStatusChartType({ chartType: eventDataChartType, sectionId, widgetId }));
        if (eventDataChartSeriesTypes) {
            dispatch(setCurrentChartSeriesTypes({ chartSeriesTypes: eventDataChartSeriesTypes, sectionId, widgetId }));
        }
    };
    const dataSwitch = listAvailableChart(chartTypeAvailable, widgetId);
    dataSwitch.forEach((e) => isChecked(e, chartType, chartSeriesTypes));
    return chartTypeAvailable
        ? React.createElement("div", null,
            React.createElement(AuxSegmentedControl, { contentEditable: false, data: dataSwitch, size: "small", onControlSelectionChanged: onControlSelectionChanged }))
        : React.createElement(React.Fragment, null);
};
